module.exports = __webpack_public_path__ + "img/icon_e42.cc63a946.png";